<template>
    <div id="course">
        <router-view />
    </div>
</template>

<script>
import CourseList from "./CourseList";
import CourseDetail from "./CourseDetail";

export default {
    name: "Course",
    components: { CourseList, CourseDetail },
    data() {
        return {
            userId: localStorage.getItem("userId") || "",
            token: localStorage.getItem("token") || ""
        };
    },
    mounted() {
        this.addDataBuried();
    },
    methods: {
        addDataBuried() {
            let headers = {
                equipmentType: "3", //设备类型： 1：安卓、  2 ：IOS 、 3 ： H5
                phoneModel: "", //手机型号
                appVersionNumber: "" //app版本号
            };
            this.$axios
                .post(
                    "/SD/statistic/addDataBuried",
                    this.$qs.stringify({
                        usergid: this.userId,
                        moduleType: "11",
                        subModuleType: "4",
                        locationType: "1",
                        disMobile: "PC"
                    }),
                    {
                        headers
                    }
                )
                .then(res => {});
        }
    }
};
</script>
